import React, { useEffect, useState } from "react";
import { SlOptions } from "react-icons/sl";
import { IoMdNotifications } from "react-icons/io";
import { Newspaper } from "lucide-react";
import MenueBar from "./modals/ModalMenue";
import { FilterModal } from "./modals/FilterModal";
import { SearchModal } from "./modals/SearchModal";
import { motion } from "framer-motion";
import { GoArrowRight } from "react-icons/go";
import NewsService from "../../services/News";
import { MdErrorOutline } from "react-icons/md";
import { useContext } from "react";
import { SafeAreaContext } from "../../App";
import NewsCard from "./modals/NewsCard";
import { FaHeart } from "react-icons/fa";
import { FaComment } from "react-icons/fa";
import { FaShare } from "react-icons/fa";
import CommentsModal from "./modals/CommentsModal";

const AllNews = () => {
  //safArea for Pwa////////
  const { setSafeAreaColor } = useContext(SafeAreaContext);
  const [id, setId] = useState(null);

  useEffect(() => {
    setSafeAreaColor({ background: "#FFFFFF" });
  }, []);
  ////////////////////////

  //Menuebar//////////////////
  const [showModal, setShowModal] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // searching Modal
  const [openSearchToggle, setOpenSearchToggle] = useState(false);
  const [seraching, setSearching] = useState("");
  // searching Modal

  //filter modal
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [openFilterToggle, setOpenFilterToggle] = useState(false);
  const [showFilterToggle, setShowFilterToggle] = useState(false);
  //comment modal
  const [isCommentsModal, setIsCommentsModal] = useState(false);

  ////////////////////////////

  function clickOnManueBarButton(e) {
    setShowModal((prev) => !prev);
    e.stopPropagation();
    if (isClosing) {
      setTimeout(() => {
        setIsClosing((prev) => !prev);
      }, 300);
    } else {
      setIsClosing((prev) => !prev);
    }
  }

  const headerAnimation = (
    <div className="flex justify-center items-center gap-2">
      <div className="nav-icon text-2xl flex items-end justify-center w-8 h-8 space-x-0.5 relative">
        <Newspaper size={30} className="text-primary animate-pulse" />
      </div>

      <div className="flex flex-col justify-center items-center mt-2">
        <h1 className="text-2xl font-bold text-text-primary text-center">
          News
        </h1>
      </div>
    </div>
  );

  // Apis and data
  const [regions, setRegions] = useState([]);
  const [news, setNews] = useState([]);

  async function getAllNews(search = "", region = "all") {
    try {
      const params = { search };
      if (region !== "all") params.region = region;
      const res = await NewsService.getAllNews(params);
      setNews(res?.data?.data ?? []);
    } catch (err) {
      console.log(err);
    }
  }

  async function getAllRegions() {
    try {
      const res = await NewsService.GetAllRegions({});
      setRegions(res?.data?.data ?? []);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getAllRegions();
  }, []);

  useEffect(() => {
    getAllNews(seraching, selectedFilter);
  }, [seraching, selectedFilter]);

  useEffect(() => {
    if (!isCommentsModal) {
      getAllNews(seraching, selectedFilter);
    }
  }, [isCommentsModal]);

  return (
    <div className="flex min-h-screen flex-col bg-light text-text-primary">
      <SearchModal
        open={openSearchToggle}
        search={seraching}
        onClose={() => {
          setOpenSearchToggle(false);
        }}
        onSearch={(s) => {
          setSearching(s);
        }}
      ></SearchModal>
      <FilterModal
        open={openFilterToggle}
        onClose={() => setOpenFilterToggle(false)}
        regions={regions}
        selected={selectedFilter}
        onSelect={(id) => setSelectedFilter(id)}
      />
      <CommentsModal
        isCommentsModal={isCommentsModal}
        setIsCommentsModal={setIsCommentsModal}
        setId={setId}
        id={id}
      />
      {/* Header */}
      <header className="bg-white h-[80px] px-4 py-4  fixed top-0 z-20 w-full flex flex-col justify-between shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">{headerAnimation}</div>

          <div className="flex flex-row gap-2 items-center">
            {/* <button className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors">
              <IoMdNotifications className="text-orange-500" size={20} />
            </button> */}

            <div className="relative">
              <button
                onClick={clickOnManueBarButton}
                className={`flex h-10 w-10 items-center justify-center rounded-lg bg-gray-50 hover:bg-gray-100 transition-all duration-200 ${
                  showModal ? "rotate-90" : ""
                }`}
              >
                <SlOptions className="text-[#878888]" size={20} />
              </button>

              <MenueBar
                isClosing={isClosing}
                showModal={showModal}
                setOpenSearchToggle={setOpenSearchToggle}
                openSearchToggle={openSearchToggle}
                clickOnManueBarButton={clickOnManueBarButton}
                openFilterToggle={openFilterToggle}
                setOpenFilterToggle={setOpenFilterToggle}
              ></MenueBar>
            </div>
          </div>
        </div>
      </header>

      <main
        id="news-content"
        className={`px-4 pt-[90px] pb-24 transition-all duration-300 ${!openFilterToggle ? "translate-y-[0px]" : "translate-y-[350px] "} ${!openSearchToggle ? "translate-y-[0px]" : "translate-y-[300px] "} `}
        style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
      >
        <div id="news-list" className="space-y-6 mt-6 mb-4">
          {news?.map((it, index) => (
            <div key={it._id}>
              <NewsCard
                item={it}
                isCommentsModal={isCommentsModal}
                setIsCommentsModal={setIsCommentsModal}
                setId={setId}
                id={id}
              ></NewsCard>
            </div>
          ))}
        </div>

        {/* Hidden News Item 2 */}
        <div className="hidden">
          {/* News Item 2 */}
          <motion.article
            className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden w-full"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.38, delay: 0.05 }}
            whileHover={{ scale: 1.02 }}
          >
            <div className="relative h-48 overflow-hidden">
              <img
                className="w-full h-full object-cover filter blur-[1px]"
                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/b470a0687f-aa3fe06f065490d00fc7.png"
                alt="stock market chart tehran stock exchange financial analysis"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute top-4 right-4 bg-green-600 text-white text-xs px-3 py-1.5 rounded-full font-medium shadow-lg">
                بازار سهام
              </div>
              <div className="absolute bottom-4 right-4 left-4">
                <h2 className="text-xl font-bold text-white mb-2 text-right line-clamp-2 drop-shadow-lg">
                  رشد شاخص کل بورس تهران به کانال 2,500,000 واحد
                </h2>
              </div>
            </div>

            <div className="p-6">
              <p className="text-gray-700 text-sm leading-relaxed mb-5 text-right line-clamp-3">
                شاخص کل بورس اوراق بهادار تهران در معاملات امروز با رشد 25,000
                واحدی به کانال 2,500,000 واحد رسید. این رشد نشان‌دهنده بهبود
                روحیه سرمایه‌گذاران و افزایش اعتماد به بازار سرمایه است...
              </p>

              <div className="flex flex-wrap gap-2 mb-5">
                <span className="text-xs text-green-600 bg-green-50 px-3 py-1.5 rounded-full font-medium">
                  #بورس
                </span>
                <span className="text-xs text-green-600 bg-green-50 px-3 py-1.5 rounded-full font-medium">
                  #stock
                </span>
                <span className="text-xs text-green-600 bg-green-50 px-3 py-1.5 rounded-full font-medium">
                  #سهام
                </span>
                <span className="text-xs text-green-600 bg-green-50 px-3 py-1.5 rounded-full font-medium">
                  #market
                </span>
              </div>

              <div className="flex items-center justify-between text-xs text-gray-500 mb-5">
                <div className="flex items-center space-x-2 space-x-reverse">
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg"
                    alt="نویسنده"
                    className="w-8 h-8 rounded-full border-2 border-white shadow-sm"
                  />
                  <span className="font-medium text-gray-700">سارا حسینی</span>
                </div>
                <span className="bg-gray-100 px-3 py-1.5 rounded-full font-medium">
                  ۵ ساعت پیش
                </span>
              </div>

              {/* Interaction Section */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div className="flex items-center space-x-6">
                  <button className="flex items-center justify-center text-sm text-gray-400 hover:text-red-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-red-100"
                      }
                    >
                      <FaHeart size={15} className="mr-2 text-base " />
                    </div>

                    <span className="font-semibold">2</span>
                  </button>

                  <button className="flex justify-center items-center text-sm text-gray-400 hover:text-blue-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-blue-100"
                      }
                    >
                      <FaComment
                        className="mr-2 fas fa-comment"
                        size={14}
                      ></FaComment>
                    </div>

                    <span className="font-semibold">4</span>
                  </button>

                  <button className="flex items-center text-sm text-gray-400 hover:text-green-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-green-100"
                      }
                    >
                      <FaShare className="fas fa-share" size={15}></FaShare>
                    </div>
                  </button>
                </div>

                <button className="flex items-center justify-center w-12 h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all duration-200 hover:scale-105 shadow-md">
                  <GoArrowRight
                    strokeWidth={1}
                    size={25}
                    className="fas fa-arrow-right text-lg"
                  ></GoArrowRight>
                </button>
              </div>
            </div>
          </motion.article>

          {/* News Item 3 */}
          <motion.article
            className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden w-full"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.08 }}
            whileHover={{ scale: 1.02 }}
          >
            <div className="relative h-48 overflow-hidden">
              <img
                className="w-full h-full object-cover filter blur-[1px]"
                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/634c1db7fe-14e241c6822055c62527.png"
                alt="gold price chart dollar currency financial market"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute top-4 right-4 bg-yellow-600 text-white text-xs px-3 py-1.5 rounded-full font-medium shadow-lg">
                طلا و ارز
              </div>
              <div className="absolute bottom-4 right-4 left-4">
                <h2 className="text-xl font-bold text-white mb-2 text-right line-clamp-2 drop-shadow-lg">
                  کاهش قیمت طلا در بازارهای جهانی
                </h2>
              </div>
            </div>

            <div className="p-6">
              <p className="text-gray-700 text-sm leading-relaxed mb-5 text-right line-clamp-3">
                قیمت هر اونس طلا در معاملات امروز با کاهش 15 دلاری به 2,450 دلار
                رسید. این کاهش در پی تقویت دلار آمریکا و افزایش انتظارات نرخ
                بهره اتفاق افتاده است...
              </p>

              <div className="flex flex-wrap gap-2 mb-5">
                <span className="text-xs text-yellow-600 bg-yellow-50 px-3 py-1.5 rounded-full font-medium">
                  #طلا
                </span>
                <span className="text-xs text-yellow-600 bg-yellow-50 px-3 py-1.5 rounded-full font-medium">
                  #gold
                </span>
                <span className="text-xs text-yellow-600 bg-yellow-50 px-3 py-1.5 rounded-full font-medium">
                  #دلار
                </span>
                <span className="text-xs text-yellow-600 bg-yellow-50 px-3 py-1.5 rounded-full font-medium">
                  #dollar
                </span>
              </div>

              <div className="flex items-center justify-between text-xs text-gray-500 mb-5">
                <div className="flex items-center space-x-2 space-x-reverse">
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg"
                    alt="نویسنده"
                    className="w-8 h-8 rounded-full border-2 border-white shadow-sm"
                  />
                  <span className="font-medium text-gray-700">محمد رضایی</span>
                </div>
                <span className="bg-gray-100 px-3 py-1.5 rounded-full font-medium">
                  دیروز ۱۴:۳۰
                </span>
              </div>

              {/* Interaction Section */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div className="flex items-center space-x-6">
                  <button className="flex items-center justify-center text-sm text-gray-400 hover:text-red-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-red-100"
                      }
                    >
                      <FaHeart size={15} className="mr-2 text-base " />
                    </div>

                    <span className="font-semibold">2</span>
                  </button>

                  <button className="flex justify-center items-center text-sm text-gray-400 hover:text-blue-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-blue-100"
                      }
                    >
                      <FaComment
                        className="mr-2 fas fa-comment"
                        size={14}
                      ></FaComment>
                    </div>

                    <span className="font-semibold">4</span>
                  </button>

                  <button className="flex items-center text-sm text-gray-400 hover:text-green-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-green-100"
                      }
                    >
                      <FaShare className="fas fa-share" size={15}></FaShare>
                    </div>
                  </button>
                </div>

                <button className="flex items-center justify-center w-12 h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all duration-200 hover:scale-105 shadow-md">
                  <GoArrowRight
                    strokeWidth={1}
                    size={25}
                    className="fas fa-arrow-right text-lg"
                  ></GoArrowRight>
                </button>
              </div>
            </div>
          </motion.article>

          {/* News Item 4 */}
          <motion.article
            className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden w-full"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.42, delay: 0.12 }}
            whileHover={{ scale: 1.02 }}
          >
            <div className="relative h-48 overflow-hidden">
              <img
                className="w-full h-full object-cover filter blur-[1px]"
                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/634c1db7fe-14e241c6822055c62527.png"
                alt="gold price chart dollar currency financial market"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute top-4 right-4 bg-yellow-600 text-white text-xs px-3 py-1.5 rounded-full font-medium shadow-lg">
                طلا و ارز
              </div>
              <div className="absolute bottom-4 right-4 left-4">
                <h2 className="text-xl font-bold text-white mb-2 text-right line-clamp-2 drop-shadow-lg">
                  کاهش قیمت طلا در بازارهای جهانی
                </h2>
              </div>
            </div>

            <div className="p-6">
              <p className="text-gray-700 text-sm leading-relaxed mb-5 text-right line-clamp-3">
                قیمت هر اونس طلا در معاملات امروز با کاهش 15 دلاری به 2,450 دلار
                رسید. این کاهش در پی تقویت دلار آمریکا و افزایش انتظارات نرخ
                بهره اتفاق افتاده است...
              </p>

              <div className="flex flex-wrap gap-2 mb-5">
                <span className="text-xs text-yellow-600 bg-yellow-50 px-3 py-1.5 rounded-full font-medium">
                  #طلا
                </span>
                <span className="text-xs text-yellow-600 bg-yellow-50 px-3 py-1.5 rounded-full font-medium">
                  #gold
                </span>
                <span className="text-xs text-yellow-600 bg-yellow-50 px-3 py-1.5 rounded-full font-medium">
                  #دلار
                </span>
                <span className="text-xs text-yellow-600 bg-yellow-50 px-3 py-1.5 rounded-full font-medium">
                  #dollar
                </span>
              </div>

              <div className="flex items-center justify-between text-xs text-gray-500 mb-5">
                <div className="flex items-center space-x-2 space-x-reverse">
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg"
                    alt="نویسنده"
                    className="w-8 h-8 rounded-full border-2 border-white shadow-sm"
                  />
                  <span className="font-medium text-gray-700">محمد رضایی</span>
                </div>
                <span className="bg-gray-100 px-3 py-1.5 rounded-full font-medium">
                  دیروز ۱۴:۳۰
                </span>
              </div>

              {/* Interaction Section */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div className="flex items-center space-x-6">
                  <button className="flex items-center justify-center text-sm text-gray-400 hover:text-red-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-red-100"
                      }
                    >
                      <FaHeart size={15} className="mr-2 text-base " />
                    </div>

                    <span className="font-semibold">2</span>
                  </button>

                  <button className="flex justify-center items-center text-sm text-gray-400 hover:text-blue-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-blue-100"
                      }
                    >
                      <FaComment
                        className="mr-2 fas fa-comment"
                        size={14}
                      ></FaComment>
                    </div>

                    <span className="font-semibold">4</span>
                  </button>

                  <button className="flex items-center text-sm text-gray-400 hover:text-green-500 transition-colors">
                    <div
                      className={
                        "w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center pl-3 mr-2 hover:bg-green-100"
                      }
                    >
                      <FaShare className="fas fa-share" size={15}></FaShare>
                    </div>
                  </button>
                </div>

                <button className="flex items-center justify-center w-12 h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all duration-200 hover:scale-105 shadow-md">
                  <GoArrowRight
                    strokeWidth={1}
                    size={25}
                    className="fas fa-arrow-right text-lg"
                  ></GoArrowRight>
                </button>
              </div>
            </div>
          </motion.article>
        </div>
      </main>
    </div>
  );
};

export default AllNews;
